import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { routes } from "app/routes";
import { push } from "connected-react-router";
import { LandingTwoColumnLayout } from "features/landingPage/FunnelMVP/LandingTwoColumnLayout";
import celebrate from "images/celebrate.svg";
import { useDispatch } from "react-redux";
import useLocalStorage from "@rehooks/local-storage";
import { getMentorshipGroupAddOnPrice } from "@app/shared/prices";
import _ from "lodash";
import { useContext } from "react";
import { MemberContext } from "../MemberContext";
import { MembershipType } from "@app/shared/types";
import { UpdateLegacyBillingCloseIcon } from "./UpdateLegacyBillingCloseIcon";

const useStyles = makeStyles((theme) => ({
    videoColumn: {
        width: "40%",
        [theme.breakpoints.down("md")]: {
            position: "relative",
            // margin: "5%",
            width: "100%",
        },
    },
    contentWrapper: {
        width: "60%",
        marginLeft: "40%",
        paddingRight: theme.spacing(15),
        [theme.breakpoints.down("md")]: {
            minHeight: "unset",
            marginLeft: "0",
            width: "100%",
            padding: theme.spacing(8),
        },
    },
    image: {
        [theme.breakpoints.down("md")]: {
            display: "none",
        },
    },
    info: {
        marginBottom: theme.spacing(15),
    },
}));

export const UpdateLegacyBillingPage1 = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [redirectAfterBillingChange, setRedirectAfterBillingChange] = useLocalStorage<
        string | undefined
    >("REDIRECT_AFTER_BILLING_PLAN_CHANGE");
    const context = useContext(MemberContext);
    const membership = _.first(context.memberships);

    return (
        <>
            <UpdateLegacyBillingCloseIcon />
            <LandingTwoColumnLayout
                continueButtonText="Continue to make the switch"
                classes={{
                    // container: classes.container,
                    videoColumn: classes.videoColumn,
                    // video: classes.video,
                    contentWrapper: classes.contentWrapper,
                }}
                onNext={() => {
                    dispatch(push(routes.memberUpdateLegacyBillingPage2()));
                }}
                content={
                    <div className={classes.info}>
                        <div className={classes.image}>
                            <img src={celebrate} alt="" />
                        </div>

                        <Typography variant="h4">
                            Let’s switch you into our new pricing model{" "}
                        </Typography>
                        <Typography variant="body1">
                            To make this change, we’ll need to switch you to our new pricing model,
                            which we’ve made more accessible.
                        </Typography>
                        <Typography variant="body1">
                            <ul>
                                <li>
                                    <strong>You choose your price</strong> based on what you feel is
                                    right for you and the community.
                                </li>
                                <li>
                                    <strong>All memberships are now billed monthly</strong>, which
                                    we hope will make it simpler to keep track of.
                                </li>
                                {membership &&
                                    membership?.membershipType &&
                                    membership?.membershipType !== MembershipType.explorer && (
                                        <li>
                                            <strong>
                                                Your Mentorship Group is a flat $
                                                {getMentorshipGroupAddOnPrice(
                                                    membership?.membershipType,
                                                )}{" "}
                                                a month
                                            </strong>{" "}
                                            on top of your base contribution.
                                        </li>
                                    )}
                            </ul>{" "}
                        </Typography>
                    </div>
                }
                videoUrl="https://storage.googleapis.com/cloud-sangha-images/funnel-experiment-videos/Sky.mp4"
                videoId="slidingScaleExplanation"
            />
        </>
    );
};
